<div class="advanced-search-container" @fadeInOut>

  <!-- Prefill Skeleton Overlay -->
  <div class="prefill-skeleton-overlay" *ngIf="isPrefilling">
    <div class="skeleton-section">
      <div class="skeleton-line skeleton-title"></div>
      <div class="skeleton-fields-row">
        <div class="skeleton-field"><div class="skeleton-line skeleton-label"></div><div class="skeleton-line skeleton-input"></div></div>
        <div class="skeleton-field"><div class="skeleton-line skeleton-label"></div><div class="skeleton-line skeleton-input"></div></div>
      </div>
    </div>
    <div class="skeleton-section">
      <div class="skeleton-line skeleton-title"></div>
      <div class="skeleton-fields-row skeleton-3col">
        <div class="skeleton-field"><div class="skeleton-line skeleton-label"></div><div class="skeleton-line skeleton-input"></div></div>
        <div class="skeleton-field"><div class="skeleton-line skeleton-label"></div><div class="skeleton-line skeleton-input"></div></div>
        <div class="skeleton-field"><div class="skeleton-line skeleton-label"></div><div class="skeleton-line skeleton-input"></div></div>
      </div>
    </div>
    <div class="skeleton-section">
      <div class="skeleton-line skeleton-title"></div>
      <div class="skeleton-fields-row skeleton-3col">
        <div class="skeleton-field"><div class="skeleton-line skeleton-label"></div><div class="skeleton-line skeleton-input"></div></div>
        <div class="skeleton-field"><div class="skeleton-line skeleton-label"></div><div class="skeleton-line skeleton-input"></div></div>
        <div class="skeleton-field"><div class="skeleton-line skeleton-label"></div><div class="skeleton-line skeleton-input"></div></div>
      </div>
    </div>
    <div class="skeleton-section">
      <div class="skeleton-line skeleton-title"></div>
      <div class="skeleton-field skeleton-field-full"><div class="skeleton-line skeleton-label"></div><div class="skeleton-line skeleton-input"></div></div>
    </div>
  </div>

  <!-- Search Form -->
  <div class="search-form-container" [style.display]="isPrefilling ? 'none' : null">
    <form [formGroup]="advancedSearchForm" (ngSubmit)="onSearch()">

      <!-- Personal Info Section -->
      <div class="form-section">
        <h3 class="section-title">Personal Info</h3>
        <div class="row g-2">
          <div class="col-md-6">
            <label class="field-label">Name</label>
            <input
              type="text"
              formControlName="fullName"
              class="form-control"
              placeholder=""
              (keydown)="allowOnlyAlphabets($event)"
            />
          </div>

          <div class="col-md-6">
            <label class="field-label">Alternate Contact Number</label>
            <input
              type="text"
              maxlength="12"
              formControlName="alternateContactNumber"
              class="form-control"
              placeholder=""
              (keydown)="allowOnlyNumbers($event)"
            />
          </div>
        </div>
      </div>

      <!-- Address Section -->
      <div class="form-section">
        <h3 class="section-title">Address</h3>
        <div class="row g-2">
          <div class="col-md-4">
            <label class="field-label">Address</label>
            <input
              type="text"
              formControlName="address"
              class="form-control"
              placeholder=""
            />
          </div>

          <div class="col-md-4">
            <label class="field-label">State</label>
            <app-common-dropdown
              [filterType]="'select'"
              [searchable]="true"
              [multipleSelection]="true"
              [showRemoveBadge]="true"
              [items]="stateItems"
              placeholder="Select"
              [selectedItems]="selectedState"
              (itemsSelected)="onStateSelect($event)"
            ></app-common-dropdown>
          </div>

          <div class="col-md-4">
            <label class="field-label">Zip Code</label>
            <input
              type="text"
              maxlength="5"
              formControlName="zipCode"
              class="form-control"
              placeholder=""
              (keydown)="allowOnlyNumbers($event)"
            />
          </div>
        </div>
      </div>

      <!-- Account Section -->
      <div class="form-section">
        <h3 class="section-title">Account</h3>
        <div class="row g-2">
          <div class="col-md-4">
            <label class="field-label">Account Status</label>
            <app-common-dropdown
              [filterType]="'select'"
              [multipleSelection]="true"
              [searchable]="true"
              [showRemoveBadge]="true"
              [items]="customerStatusItems"
              placeholder="Select"
              [selectedItems]="selectedCustomerStatus"
              (itemsSelected)="onCustomerStatusSelect($event)"
            ></app-common-dropdown>
          </div>

          <div class="col-md-4">
            <label class="field-label">Order Type</label>
            <app-common-dropdown
              [filterType]="'select'"
              [multipleSelection]="true"
              [searchable]="true"
              [showRemoveBadge]="true"
              [items]="orderTypeItems"
              placeholder="Select"
              [selectedItems]="selectedOrderType"
              (itemsSelected)="onOrderTypeSelect($event)"
            ></app-common-dropdown>
          </div>

          <div class="col-md-4">
            <label class="field-label">Account Type</label>
            <app-common-dropdown
              [filterType]="'select'"
              [multipleSelection]="true"
              [searchable]="true"
              [showRemoveBadge]="true"
              [items]="accountTypeItems"
              placeholder="Select"
              [selectedItems]="selectedAccountType"
              (itemsSelected)="onAccountTypeSelect($event)"
            ></app-common-dropdown>
          </div>
        </div>
      </div>

      <!-- Application & Subscriber IDs (conditional) -->
      <div class="form-section" *ngIf="isNladVisible() || isNvSubscriberVisible()">
        <h3 class="section-title">Additional Information</h3>
        <div class="row g-2">
          <div class="col-md-6" *ngIf="isNladVisible()">
            <label class="field-label">Nlad Application ID</label>
            <input
              formControlName="nladApplicationId"
              class="form-control"
              placeholder=""
            />
          </div>

          <div class="col-md-6" *ngIf="isNvSubscriberVisible()">
            <label class="field-label">NV Subscriber ID</label>
            <input
              formControlName="nvSubscriberId"
              class="form-control"
              placeholder=""
            />
          </div>
        </div>
      </div>

      <!-- Date Range Section -->
      <div class="form-section">
        <h3 class="section-title">Date Range</h3>
        <div class="row g-2">
          <div class="col-12">
            <div class="date-picker-wrapper">
              <button
                #dateRangeBtn
                type="button"
                class="form-control date-range-button"
                (click)="toggleCalendar()"
                (mousedown)="onDateRangeBtnMouseDown()"
                (focus)="onDateRangeBtnFocus()"
                (keydown)="onDateRangeBtnKeydown($event)"
              >
                <span [class.placeholder-text]="!(customDateRange && customDateRange.length === 2)">{{ customDateRange && customDateRange.length === 2 ? (formatDateForDisplay(customDateRange[0]) + ' - ' + formatDateForDisplay(customDateRange[1])) : 'DD-MM-YYYY' }}</span>
                <i class="fas fa-calendar-alt"></i>
              </button>

              <!-- Date Range Picker Component (tooltip/popup mode) -->
              <app-date-range-picker
                [show]="showCalendar"
                [inline]="false"
                [triggerElement]="dateRangeBtn"
                [singleDateMode]="false"
                (dateRangeSelected)="onDateRangeSelected($event)"
                (showChange)="showCalendar = $event"
              ></app-date-range-picker>
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>

  <!-- Action Buttons -->
  <div class="form-actions">
    <button
      type="button"
      (click)="onReset()"
      class="btn btn-outline-secondary modern-btn"
    >
      Reset
    </button>
    <button
      type="button"
      (click)="onSearch()"
      class="btn btn-primary modern-btn"
      [disabled]="isLoading"
    >
      {{ isLoading ? 'Searching...' : 'Search' }}
    </button>
  </div>

</div>
